import { FormattedMessage, useIntl } from "react-intl";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import "../DataExportActions/DataExportActions.scss";

const FORMATS = [
  {
    id: "pdf",
    labelId: "export.chart.pdf",
    Icon: PictureAsPdfOutlinedIcon,
    modifier: "pdf",
  },
  {
    id: "png",
    labelId: "export.chart.png",
    Icon: ImageOutlinedIcon,
    modifier: "png",
  },
  {
    id: "jpeg",
    labelId: "export.chart.jpeg",
    Icon: PhotoOutlinedIcon,
    modifier: "jpeg",
  },
];

function ChartExportActions({
  className = "",
  hasData = false,
  onExportPdf,
  onExportPng,
  onExportJpeg,
}) {
  const intl = useIntl();

  const disabledTitle = hasData
    ? undefined
    : intl.formatMessage({ id: "export.noData" });

  const handlers = {
    pdf: () => hasData && onExportPdf?.(),
    png: () => hasData && onExportPng?.(),
    jpeg: () => hasData && onExportJpeg?.(),
  };

  return (
    <div className={`data-export-actions ${className}`.trim()}>
      <div className="data-export-actions__header">
        <FileDownloadOutlinedIcon className="data-export-actions__header-icon" />
        <span className="data-export-actions__header-text">
          <FormattedMessage id="export.chart.formats" />
        </span>
      </div>

      <div className="data-export-actions__buttons">
        {FORMATS.map(({ id, labelId, Icon, modifier }) => (
          <button
            key={id}
            type="button"
            className={`data-export-actions__btn data-export-actions__btn--${modifier}${
              !hasData ? " data-export-actions__btn--disabled" : ""
            }`}
            onClick={handlers[id]}
            disabled={!hasData}
            title={disabledTitle || intl.formatMessage({ id: labelId })}
            aria-label={intl.formatMessage({ id: labelId })}
          >
            <Icon className="data-export-actions__format-icon" fontSize="small" />
            <span>
              <FormattedMessage id={labelId} />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ChartExportActions;
